export const RESET = 'USERDATA_LIST_RESET'
export const SET_ITEMS = 'USERDATA_LIST_SET_ITEMS'
export const SET_ERROR = 'USERDATA_LIST_SET_ERROR'
export const SET_VIEW = 'USERDATA_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'USERDATA_LIST_TOGGLE_LOADING'
export const SET_TOTAL_ITEMS = 'USERDATA_LIST_SET_TOTAL_ITEMS'
